export const JOB_STATUS_OPTIONS = [
  'Part-time',
  'Full-time, employeed but open to opportunities',
  'Full-time, immediate start',
  'Internship',
  'Consulting',
  'Volunteer',
];
